<template>
  <div id="ClientDomains">
      <v-container class="pa-0">
        <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute right class="mr-3 pf-btn-fab" :to="'/admin/domains/add'">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
        </v-layout>
      </v-container>
      <v-container grid-list-md fluid class="pt-0">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-card class="mt-1">
          <v-data-table
            :headers="headers"
            :items="ClientDomains"
            :search="search"
            class="pf-data-table" 
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.nickname }}</td>
              <td>{{ props.item.ppn }}</td>
              <td><a :href="`${ props.item.contactInfo.website.indexOf('http') > -1 ? props.item.contactInfo.website : ('http://' + props.item.contactInfo.website) }`" target="_blank">{{ props.item.contactInfo.website.indexOf('http') > -1 ? props.item.contactInfo.website : ('http://' + props.item.contactInfo.website) }}</a></td>
              <td align="right">
                <v-btn icon class="ma-0" @click="editItem(props.item)">
                  <v-icon size="22" color="grey darken-2">edit</v-icon>
                </v-btn>
                <v-btn icon class="ma-0" @click="deleteItem(props.item)">
                  <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
  </div>
</template>

<script>
/* global session store config  */
import swal from 'sweetalert2';
import { getCollection, request } from '../../helpers/helpers';
import { mapGetters } from 'vuex';

// This lists all the countries and allow to edit them.
export default {
  name: 'ClientDomains',
  data: () => ({
    search: '',
    headers: [
      { text: 'Family', value: 'name', align: 'left' },
      { text: 'Nickname', value: 'nickname', align: 'left' },
      { text: 'PPN', value: 'ppn', align: 'left' },
      { text: 'Website', value: 'contactInfo.website', align: 'left' },
      { text: '', sortable: false },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage
    },  
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ClientDomains: {
      set (value) {
        store.commit('setClientDomains', value);
      },
      get () {
        return store.state.ClientDomains;
      }
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    // @vuese
    // Used to fetch the country list if not already exists
    async initialize () {
      if (!this.ClientDomains.length) {
        let entity = 'Account';
        let where = { 'contactInfo.website': { '$exists': true, '$ne': '' }, 'membership': { '$exists': true, '$ne': 'Network' }};
        let attributes = 'profile_number,profile_year,contactInfo.website,name,nickname';
        let sort = { 'createdAt': -1 };
        let { error, data } = await getCollection(entity, true, 0, '', where, attributes, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.ClientDomains = data;
          }
        }
      }
    },
    // @vuese
    // Used to setup to edit the country
    // @arg The country item to be edited
    editItem (item) {
      let family = JSON.parse(JSON.stringify(item));
      family.text = family.nickname;
      this.$router.push({ name: 'AddClientDomains', params: { family: family }});
    },
    async deleteItem (item) {
      let itemIndex = this.ClientDomains.indexOf(item);
      if (item.id && itemIndex > -1) {
        swal.fire({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then(result => {
          if (result.value) {
            (async () => {
              let deletePayload = {
                account: item.id,
                type: config.parentDomain.type
              };
              let { error, data, status } = await request('Cloudflare/DeleteDNS', 'POST', deletePayload);
              if (error) {
                console.log('error', error);
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: `Failed to remove the domain, ${error}`
                };
              } else {
                /* Remove the entry from ClientDomains */
                this.ClientDomains.splice(itemIndex, 1);

                swal.fire({
                  type: 'success',
                  title: 'Deleted!',
                  text: 'The selected domain has been deleted.',
                  showConfirmButton: false,
                  timer: 2500,
                  onClose: () => {}
                });
              }
            })();
          }
        });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ClientDomains/list.vue